var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer container"},[_c('p',{staticClass:"one"},[_vm._v(" 网站首页 | 关于我们 | 广告合作 | 联系我们 | 隐私条款 | 免责声明 ")]),_c('p',{staticClass:"two"},[_c('a',{attrs:{"href":"https://beian.miit.gov.cn/#/Integrated/recordQuery","target":"_blank"}},[_vm._v("蜀ICP备2021001179号-1")])])])
}]

export { render, staticRenderFns }